module.exports = __webpack_public_path__ + "img/1-sm.f3625729.jpg";